import { useEffect } from "react";

import { track } from "../../analytics";
import { OCTOBER, octoberEvents } from "../../content/october";
import { Page } from "../../layout/Page";
import { Mahamandir } from "../../ui/Mahamandir";
import { Masters } from "../../ui/Masters";
import { Section } from "../../ui/Section";

import { RegisterForm } from "./RegisterForm";

/** One programme in the visit, date bold, with what it asks of the reader:
 *  the invitation-only dialogues say so, the open days point at the form. */
function ProgrammeLine({
  dateLabel,
  title,
  note,
}: {
  dateLabel: string;
  title: string;
  note: string;
}) {
  return (
    <li className="text-base text-ink md:text-lg">
      <strong className="font-semibold">{dateLabel}</strong>: {title}{" "}
      <span className="text-sm whitespace-nowrap text-teal-deep">{note}</span>
    </li>
  );
}

export function RegisterPage() {
  const params = new URLSearchParams(window.location.search);
  const resumeRef = params.get("resume") === "hawan" ? params.get("ref") : null;
  const [stage, hawan] = octoberEvents();
  useEffect(() => {
    track("register_viewed", { resume: Boolean(resumeRef) });
  }, [resumeRef]);
  return (
    <Page title="Register" heading="Register for October Programmes">
      <Section eyebrow="1 to 4 October 2026">
        <div className="max-w-3xl">
          <p className="font-display text-xl leading-snug text-ink md:text-2xl">
            Swamiji is coming to Singapore
          </p>
          <p className="mt-3 max-w-prose text-base text-ink-soft md:text-lg">
            {OCTOBER.visit.occasion}
          </p>
          <div className="mt-6 grid gap-5" data-testid="register-days">
            {OCTOBER.invitationOnly.length > 0 ? (
              <div>
                <p className="eyebrow">By invitation only</p>
                <ul className="mt-2 grid gap-1.5">
                  {OCTOBER.invitationOnly.map((p) => (
                    <ProgrammeLine
                      key={p.title}
                      dateLabel={p.dateLabel}
                      title={p.title}
                      note="Invitation only, no registration here"
                    />
                  ))}
                </ul>
              </div>
            ) : null}
            <div>
              <p className="eyebrow">Open to all</p>
              <ul className="mt-2 grid gap-1.5">
                {[stage, hawan].map((event) =>
                  event ? (
                    <ProgrammeLine
                      key={event.slug}
                      dateLabel={event.dateLabel}
                      title={event.title}
                      note="Register below"
                    />
                  ) : null,
                )}
              </ul>
            </div>
          </div>
          <p className="mt-3 text-base text-ink-soft md:text-lg">
            One form for 3 and 4 October, one reference, bring the whole family.
          </p>
          <Masters className="mt-8" />
          <div className="mt-10">
            <RegisterForm resumeRef={resumeRef} />
          </div>
          <Mahamandir className="mt-14" />
        </div>
      </Section>
    </Page>
  );
}
